var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuw-video-player vuw-vimeo-player"},[_c('div',{staticClass:"vuw-video"},[_c('div',{ref:"playerPlaceholder",attrs:{"id":"player"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }